//conver uppercase function
export function firstLetterCase(str) {
   return (str.charAt(0).toUpperCase() + str.slice(1));
}